import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { fetchList } from '../redux/list';
import ListPage from './list_page';

const ListPageContainer = (props: RouteComponentProps<{ url_slug: string }>) => {
  const { match } = props;
  const dispatch = useDispatch();

  useFrontload(`ListPageContainer:${match.params.url_slug}`, async () => {
    await dispatch(fetchList(match.params.url_slug));

    return true;
  });

  return <ListPage />;
};

export default ListPageContainer;
